import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const constantArray: { [key: string]: string } = {
  '{{productName}}': 'SOTI XSight',
  '{{nestProductName}}': 'MobiControl',
  '{nestProductNameCap}}': 'MOBICONTROL',
  '{{nestProductNameAbb}}': 'MC',
  '{{companyName}}': 'SOTI',
  '{{SMTP}}': 'SMTP',
  '{{SSL}}': 'SSL',
  '{{MAC}}': 'MAC',
  '{{IMEI}}': 'IMEI',
};

@Pipe({
  name: 'xsI18n',
  pure: false,
})
export class XsI18nPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string, ...argsArray: any[]): any {
    if (!value) {
      return value;
    }

    let result = this.translate.instant(value || '*n/a*');

    // replace the arguments...
    if (typeof result === 'string') {
      for (let i = 0; i < argsArray.length; i++) {
        const repStr = '{{' + i + '}}';
        if (argsArray[i] !== undefined) {
          result = (<string>result).replace(repStr, argsArray[i].toString());
        }
      }

      // replace the constants
      result = result.replace(/{{(.*?)}}/g, key => constantArray[key] || key);
    }
    return result;
  }
}
